import { defineMessage } from 'react-intl';

export const notificationPreferencesTitleMessage = defineMessage({
  id: 'notifications.preferences.title',
  defaultMessage: 'Preferencias de notificaciones',
});

export const notificationPreferencesInAppLabel = defineMessage({
  id: 'notifications.preferences.channel.inApp',
  defaultMessage: 'En app',
});

export const notificationPreferencesEmailLabel = defineMessage({
  id: 'notifications.preferences.channel.email',
  defaultMessage: 'Email',
});

export const notificationPreferencesUnavailableMessage = defineMessage({
  id: 'notifications.preferences.unavailable',
  defaultMessage: 'Las preferencias de notificaciones no están disponibles.',
});

export const notificationPreferencesSaveErrorMessage = defineMessage({
  id: 'notifications.preferences.saveError',
  defaultMessage: 'No se pudieron guardar las preferencias',
});
